import { Box, Skeleton, Stack } from '@mui/material'
import { useMemo } from 'react'

function GroupsTabContentSkeleton() {
  const skeletonIds = useMemo(() => Array.from({ length: 6 }, () => crypto.randomUUID()), [])

  return (
    <Box sx={{ p: 2, pl: 0, display: 'flex', flexDirection: 'column', height: '100%' }}>
      {/* Search bar skeleton */}
      <Box sx={{ mb: 2, pl: 2 }}>
        <Skeleton height={40} variant="rounded" width="100%" />
      </Box>

      {/* Available groups header skeleton */}
      <Box sx={{ mb: 2, pl: 2 }}>
        <Skeleton height={24} variant="text" width="60%" />
      </Box>

      {/* Capacity summary skeleton */}
      <Box sx={{ mb: 2, pl: 2 }}>
        <Stack spacing={1.5}>
          <Stack direction="row" justifyContent="space-between">
            <Skeleton height={20} variant="text" width="40%" />
            <Skeleton height={20} variant="text" width="20%" />
          </Stack>
          <Stack direction="row" justifyContent="space-between">
            <Skeleton height={20} variant="text" width="40%" />
            <Skeleton height={20} variant="text" width="20%" />
          </Stack>
          <Stack direction="row" justifyContent="space-between">
            <Skeleton height={20} variant="text" width="40%" />
            <Skeleton height={20} variant="text" width="20%" />
          </Stack>
        </Stack>
      </Box>

      {/* Groups list skeleton - scrollable area */}
      <Box sx={{ flexGrow: 1, minHeight: '200px', overflowY: 'auto', mb: 2, pl: 2 }}>
        <Stack spacing={1}>
          {skeletonIds.map((id) => (
            <Skeleton key={id} height={60} variant="rounded" width="100%" />
          ))}
        </Stack>
      </Box>

      {/* Selection actions skeleton - full width button */}
      <Box sx={{ pl: 2 }}>
        <Skeleton height={30} variant="rounded" width="100%" />
      </Box>
    </Box>
  )
}

export default GroupsTabContentSkeleton
